import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import API from "../Network/API";
import { Trans, useTranslation } from "react-i18next";

export default function ForgotPassword(){
    const { t } = useTranslation();

    const [email, setEmail] = useState("");

    const [isLoading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const dispatch = useDispatch();
    const navigate=useNavigate();

    const handleSubmit = (event) => {
        
        event.preventDefault();
        setMessage('');
        setError('');

        var data = {
            'email': email,
          }
          setLoading(true);
        API.post('/v1/oauth/forgot-password', data).then(response => { 
            setMessage(response.data.message);
            setLoading(false);
        }).catch((err) => { 
            setLoading(false);
            if (err.response && err.response.data && err.response.data.message) {
                setError(err.response.data.message);
            } else {
                setError(t('forgotPassword.error_try_again'));
            }
         });
    }

    return (
        <>
         <div className="sign-in-section">
        <div className="container">
          <div className="main-max-width d-flex justify-content-center mxw-400px">
            <div className="sign-content">
              <div className="box-content mb-4">
                <h4>{t('forgotPassword.forgot_your_password_title')}</h4>
                <div className="singup-link ">
                  <span className>
                    <Link to={`/signup-student`} className="text-decoration-underline text-dark me-1">{t('forgotPassword.sign_up_as_student')}</Link>
                  </span>
                  <span className="text-dark">{t('forgotPassword.or')}</span>
                  <span>
                    <Link to={`/signup-tutor`} className="text-decoration-underline text-dark ms-1">{t('forgotPassword.sign_up_as_tutor')}</Link>
                  </span>
                </div>
              </div>
              <div className="acount-s mb-20 d-none">
                <a href="#" className="btn rounded-pill w-100 mb-2 input-hight-44">
                  <img src="assets/img/google.svg" alt={t('forgotPassword.image_alt')} /> {t('forgotPassword.sign_in_with_google')}
                </a>
                <a href="#" className="btn rounded-pill w-100 mb-2 input-hight-44">
                  <img src="assets/img/facebook-3-logo-svgrepo-com.svg" alt={t('forgotPassword.image_alt')} /> {t('forgotPassword.sign_in_with_facebook')}
                </a>
                <a href="#" className="btn rounded-pill w-100 mb-2 input-hight-44">
                  <img src="assets/img/apple-logo-svgrepo-com.svg" alt={t('forgotPassword.image_alt')} /> {t('forgotPassword.continue_with_apple')}
                </a>
              </div>
              <div className="loginDivider d-none">
                <p className="loginDivider-text mb-0">{t('forgotPassword.or')}</p>
              </div>
              <div className="log-from mb-30">
                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-2">
                    <label htmlFor="exampleInputEmail1" className="form-label ">{t('forgotPassword.email')}</label>
                    <input defaultValue={email} required onChange={(e) => setEmail(e.target.value)} type="email" className="form-control rounded-pill input-hight-44" id="exampleInputEmail1" placeholder={t('forgotPassword.your_email')} />
                  </div>
             
                
                  <button type="submit" className="input-hight-44 btn btn-login w-100 box-shadow-1 rounded-pill fw-bold">{t('forgotPassword.send_reset_link')} {isLoading ? (
                    <span
                      className="spinner-border spinner-border-sm ml-5"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    <span></span>
                  )}</button>
                </form>

                {message && <p className="success-message">{message}</p>}
                {error && <p className="error-message">{error}</p>}

              </div>
              <div className="sign-link text-center">
                <span><Trans i18nKey="forgotPassword.terms_agreement" components={{ termsLink: <Link to={`/terms`} className="main-colo" />, privacyLink: <Link to={`/privacy-policy`} className="main-colo" /> }} /></span>
              </div>
            </div>
          </div>
        </div>
      </div>
        </>
    )
}